export default __webpack_public_path__ + "static/media/balancePrimary.3adc45ea.png";